import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ModalService } from 'src/app/shared/service/modal.service';

export type HomeCuentaPoliticasTipo = 'T' | 'P';

@Component({
  selector: 'app-home-cuenta-politicas-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './home-cuenta-politicas-modal.component.html',
  styleUrls: ['./home-cuenta-politicas-modal.component.scss'],
})
export class HomeCuentaPoliticasModalComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() tipo: HomeCuentaPoliticasTipo = 'P';
  @Input() open = false;
  @Output() readonly closed = new EventEmitter<void>();
  @Output() readonly accepted = new EventEmitter<HomeCuentaPoliticasTipo>();

  @ViewChild('bodyEl') private bodyEl?: ElementRef<HTMLElement>;

  /** En términos exige llegar al final del texto (mismo criterio del modal legacy). */
  acceptEnabled = true;

  constructor(
    public readonly modalService: ModalService,
    private readonly host: ElementRef<HTMLElement>
  ) {}

  get title(): string {
    return this.tipo === 'T'
      ? 'Términos y condiciones'
      : 'Políticas tratamiento de datos personales';
  }

  ngOnInit(): void {
    // Evita que transform/overflow del formulario recorten el modal:
    // se monta en body para ocupar toda la pantalla.
    document.body.appendChild(this.host.nativeElement);
  }

  ngOnDestroy(): void {
    document.body.style.overflow = '';
    this.host.nativeElement.remove();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['open'] || changes['tipo']) {
      this.acceptEnabled = this.tipo !== 'T';
      if (this.open && this.tipo === 'T') {
        queueMicrotask(() => {
          if (this.bodyEl?.nativeElement) {
            this.bodyEl.nativeElement.scrollTop = 0;
          }
          this.onBodyScroll();
        });
      }
      if (this.open) {
        document.body.style.overflow = 'hidden';
      } else if (changes['open']) {
        document.body.style.overflow = '';
      }
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.open) {
      this.salir();
    }
  }

  onBodyScroll(): void {
    if (this.tipo !== 'T' || !this.bodyEl) {
      this.acceptEnabled = true;
      return;
    }
    const el = this.bodyEl.nativeElement;
    const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 24;
    this.acceptEnabled = nearBottom;
  }

  salir(): void {
    document.body.style.overflow = '';
    this.closed.emit();
  }

  aceptar(): void {
    if (!this.acceptEnabled) {
      return;
    }
    document.body.style.overflow = '';
    this.accepted.emit(this.tipo);
    this.closed.emit();
  }

  openLink(url: string, event: Event): void {
    event.preventDefault();
    this.modalService.enlaceModal(url);
  }

  /** Evita que #ancla dispare navegación Angular (/neocredito/#...) y scrollea dentro del modal. */
  scrollToAnchor(anchorId: string, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    const target = document.getElementById(anchorId);
    const container = this.bodyEl?.nativeElement;
    if (!target || !container) {
      return;
    }
    const top =
      target.getBoundingClientRect().top -
      container.getBoundingClientRect().top +
      container.scrollTop -
      8;
    container.scrollTo({ top, behavior: 'smooth' });
  }
}
